<template>
  <Index v-if="!isServiceEnd" />
  <ServiceEnd v-else />
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Index from '@/index/components/2026/Index.vue'
import ServiceEnd from '@/common/components/ServiceEnd.vue'

const isServiceEnd = ref(false)

onMounted(() => {
  isServiceEnd.value = new Date() > new Date('2026-03-31T23:59:59')
})
</script>
